export var Authorization;
(function (Authorization) {
    // Keys: align with schema/schema.graphql#RequiredPermission
    // Values: defined in Auth0 API settings
    // Mappings: see api/src/graphql/requiresPermissionDirective.ts
    let Permissions;
    (function (Permissions) {
        Permissions["ReadData"] = "read:data";
        Permissions["ReadConfig"] = "read:config";
        Permissions["WriteConfig"] = "write:config";
        Permissions["ReadSettings"] = "read:settings";
        Permissions["WriteSettings"] = "write:settings";
        Permissions["CrossTenantAdmin"] = "xtenant";
    })(Permissions = Authorization.Permissions || (Authorization.Permissions = {}));
})(Authorization || (Authorization = {}));
export var AuthenticationConfiguration;
(function (AuthenticationConfiguration) {
    AuthenticationConfiguration.Domain = "grumpycorp.auth0.com";
    AuthenticationConfiguration.Audience = "https://api.warmandfuzzy.house";
    AuthenticationConfiguration.CustomClaimsNamespace = "https://warmandfuzzy.house/";
    AuthenticationConfiguration.CustomClaims = {
        // Id token
        UserName: "user_name",
        UserEmail: "user_email",
        // Access token
        Tenant: "tenant",
    };
    AuthenticationConfiguration.ClientId = "d2iox6iU52feMZVugq4GIiu0A4wKe70J";
})(AuthenticationConfiguration || (AuthenticationConfiguration = {}));
//# sourceMappingURL=Auth.js.map